var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import clsx from 'clsx';
import React, { useState } from 'react';
import './UiInput.css';
import { UiIconMaterial, UiFlex, UiLoader, UiText } from '..';
export function UiInput(_a) {
    var label = _a.label, name = _a.name, placeholder = _a.placeholder, isLoading = _a.isLoading, disabled = _a.disabled, noBorder = _a.noBorder, value = _a.value, onChangeValue = _a.onChangeValue, adornmentStart = _a.adornmentStart, adornmentEnd = _a.adornmentEnd, type = _a.type, size = _a.size, flex = _a.flex, options = _a.options, readOnly = _a.readOnly, className = _a.className, inputProps = _a.inputProps, nullable = _a.nullable, fullWidth = _a.fullWidth;
    size = size || 0;
    var isCurrency = type === 'currency';
    var id = useState(Math.random().toString())[0];
    if (isLoading) {
        disabled = true;
        adornmentEnd = React.createElement(UiLoader, null);
    }
    if (options || type === 'select') {
        type = 'select';
        if (nullable) {
            options = __spreadArrays([
                {
                    label: 'None',
                    value: null,
                }
            ], options);
        }
    }
    if (isCurrency) {
        type = 'number';
        if (value > 0 || value < 0 || value === 0) {
            value = Number(Math.round(value)) / 100;
        }
        else {
            value = '';
        }
    }
    function handleChange(event) {
        var _a;
        var targetValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        if (type === 'checkbox') {
            onChangeValue(!value);
        }
        else if (type === 'select' && targetValue === 'None') {
            onChangeValue(null);
        }
        else if (isCurrency) {
            onChangeValue(targetValue && Number(targetValue) * 100);
        }
        else {
            onChangeValue(targetValue);
        }
    }
    var propsShared = {
        id: id,
        name: name,
        placeholder: placeholder ? placeholder : label,
        value: value,
        type: type,
        disabled: disabled,
        onChange: handleChange,
        readOnly: readOnly,
    };
    var input = (type === 'select' && (React.createElement("select", __assign({}, propsShared, inputProps, { value: value || '' }),
        React.createElement("option", { value: "", disabled: true }, placeholder || 'Choose value'), options === null || options === void 0 ? void 0 :
        options.map(function (_a) {
            var label = _a.label, value = _a.value;
            return (React.createElement("option", { value: value, key: value }, label));
        })))) ||
        (type === 'checkbox' && (React.createElement(UiFlex, null,
            React.createElement(UiText, { color: value ? 'secondary' : 'default' }, value ? (React.createElement(UiIconMaterial, null, "check_box")) : (React.createElement(UiIconMaterial, null, "check_box_outline_blank"))),
            React.createElement("span", null, label || placeholder),
            React.createElement("input", __assign({}, propsShared, inputProps, { size: 1, value: label || placeholder }))))) ||
        (type === 'textarea' && React.createElement("textarea", __assign({}, propsShared, inputProps))) || (React.createElement("input", __assign({}, propsShared, inputProps, { size: 1 })));
    return (React.createElement("label", { className: clsx('UiInput', "size-" + size, readOnly && "readOnly", flex && "flex", type && "type-" + type, disabled && "disabled", isLoading && "isLoading", noBorder && "noBorder", fullWidth && "fullWidth", className), htmlFor: id },
        label && value && React.createElement("div", { className: "label animated fadeIn" }, label),
        adornmentStart && React.createElement("div", { className: "adornment-start" }, adornmentStart),
        input,
        adornmentEnd && React.createElement("div", { className: "adornment-end" }, adornmentEnd),
        type === 'select' && !readOnly && React.createElement(UiIconMaterial, { className: "select-icon" }, "unfold_more")));
}
